import React from "react";
import { cleanDate } from "../../../../util/app";
import TimeAgo from "react-timeago";

const CarePlanList = ({ items = [], onView, onConfirm }) => {
    const tHeads = [
        { title: "SN", width: "5%", className: "text-center" },
        { title: "Title", width: "15%", className: "text-left" },
        { title: "Reason for Careplan", width: "15%", className: "text-left" },
        { title: "Next Evaluation Date", width: "15%", className: "text-left" },
        {
            title: "Discipline",
            width: "10%",
            className: "text-center",
        },
        { title: "Status", width: "10%", className: "text-center" },
        {
            title: "Actions",
            width: "10%",
            className: "text-center",
        },
    ];

    if (items.length < 1)
        return (
            <div className="text-center text-pink fade-in">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong style={{ fontSize: "1.4em", marginTop: "1em" }}>No Care plan has been added yet</strong>
            </div>
        );
    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-bordered">
                    <thead>
                        {tHeads.map((item) => (
                            <td style={{ width: item.width, backgroundColor: "aliceblue" }} className={item.className} key={item.title}>
                                {item.title}
                            </td>
                        ))}
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={item.id} className={item.passedReview || item.terminated ? "table-danger" : "table-success"}>
                                <td className="text-center">
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td>
                                    {item.header.title}
                                    <br />
                                    <span className="badge badge-primary">
                                        LATEST UPDATE: <TimeAgo date={item.updated_at} />
                                    </span>
                                </td>
                                <td>{item.reason}</td>
                                <td>
                                    {cleanDate(item.evaluation.nextDate)}
                                    <br />
                                    <span className="badge badge-primary">
                                        <TimeAgo date={item.evaluation.nextDate} />
                                    </span>
                                </td>
                                <td className="text-center">{item.header.discipline}</td>
                                <td className="text-center">
                                    {item.terminated ? (
                                        <>
                                            <span className="badge badge-danger">Terminated</span>
                                            <p>
                                                <strong>
                                                    <TimeAgo date={item.termination_date} />
                                                </strong>
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <strong>{item.header.status}</strong>
                                            <br />
                                            {item.confirm.status ? <span className="badge badge-success">Confirmed</span> : <span className="badge badge-danger">Unconfirmed</span>}
                                        </>
                                    )}
                                </td>

                                <td className="text-center">
                                    {!item.confirm.status && (
                                        <button onClick={() => onConfirm(item)} title="Confirm" className="mdl-button mdl-button--icon mdl-button--colored btn-default ml-2">
                                            <i className="material-icons text-success">check_circle</i>
                                        </button>
                                    )}
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CarePlanList;
